module.exports = __webpack_public_path__ + "img/Logo Synoptic_Blue_Circle.f914da62.png";